import { CreateSpaceEventError } from "@src/models/spaces";

/**
 * Carries a structured CreateSpaceEventError so the create form can map a failure
 * back to the offending session/host. Thrown by the mock and intended to be
 * reconstructed from the backend's error body once the real endpoint lands.
 */
export class SpacesApiError extends Error {
  readonly detail: CreateSpaceEventError;

  constructor(detail: CreateSpaceEventError, options?: { cause?: unknown }) {
    super(detail.message, options);
    this.name = "SpacesApiError";
    this.detail = detail;
  }
}
